import { render, staticRenderFns } from "./BtnChangeBillStatus.vue?vue&type=template&id=15c2f345&"
import script from "./BtnChangeBillStatus.vue?vue&type=script&lang=js&"
export * from "./BtnChangeBillStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports